import { Note } from '../../models/dto/note.model';

export class SubscribeToBorrowerNotes {
	static readonly type = '[Note] SubscribeToBorrowerNotes';
	constructor(public borrowerId: number) {}
}

export class GetBorrowerNotes {
	static readonly type = '[Note] GetBorrowerNotes';
	constructor(public borrowerId: number) {}
}

export class AddNote {
	static readonly type = '[Note] Add';
	constructor(public note: Note) {}
}

export class DeleteNote {
	static readonly type = '[Note] Delete';
	constructor(public noteId: number) {}
}

export class UpdateNote {
	static readonly type = '[Note] Update';
	constructor(public noteId: number, public content: string) {}
}

export class ClearNoteStore {
	static readonly type = '[Note] ClearNoteStore';
    constructor(public borrowerId: number) {}
}
